<div class="search-empty-state d-flex flex-column gap-4">

  <!-- Recent Searches -->
  <app-recent-searches
    [searches]="recentSearches"
    (select)="onRecentSelect($event)"
    (remove)="removeRecent.emit($event)"
    (clearAll)="clearAllRecent.emit()"
  ></app-recent-searches>

  <!-- Trending on AIKosh -->
  <app-trending-searches
    [items]="trendingSearches"
    (select)="onTrendingSelect($event)"
  ></app-trending-searches>

  <!-- Popular Tags -->
  <app-popular-tags
    [tags]="popularTags"
    (select)="onTagSelect($event)"
  ></app-popular-tags>

</div>
